import { openDialog, closeLatestDialog, cleanDialogStack, replaceDialog } from '@patrianna/dialog-manager'
import type { ActionTypeMapFnRedeem } from '@patrianna-payments/shared-store/redeem'
import {
  redeemAvailablePaymentProvidersRequestActionName,
  redeemCloseAllDialogsActionName,
  redeemCloseLatestDialogActionName,
  redeemOpenDialogActionName,
  redeemOpenSnackbarActionName,
  redeemReplaceDialogActionName,
  redeemSetDataToLocalStorageActionName,
  redeemSentryCaptureMessageActionName,
  redeemSentryCaptureExceptionActionName,
} from '@patrianna-payments/shared-store/redeem/store/middleware-actions'
import type { AnyAction } from '@reduxjs/toolkit'

import type { MiddlewareType } from 'store/middlewares/types'
import { getAvailablePaymentProvidersRequest } from 'store/modules/appConfig/actions'
import { openSnackbar } from 'store/modules/snackbar/actions'
import type { TypedThunk } from 'store/types'
import { setDataToLocalStorage } from 'utils/localStorage'

import { handleSentryCaptureException, handleSentryCaptureMessage } from './handlers/sentry'

const actionsMap: Record<string, ActionTypeMapFnRedeem<TypedThunk>> = {
  [redeemSetDataToLocalStorageActionName]: setDataToLocalStorage,
  [redeemOpenSnackbarActionName]: openSnackbar,
  [redeemAvailablePaymentProvidersRequestActionName]: getAvailablePaymentProvidersRequest,
  [redeemSentryCaptureMessageActionName]: handleSentryCaptureMessage,
  [redeemSentryCaptureExceptionActionName]: handleSentryCaptureException,
}

const dialogActionsMap = {
  [redeemReplaceDialogActionName]: replaceDialog,
  [redeemOpenDialogActionName]: openDialog,
  [redeemCloseLatestDialogActionName]: closeLatestDialog,
  [redeemCloseAllDialogsActionName]: cleanDialogStack,
}

export const redeemMiddleware: MiddlewareType =
  ({ dispatch }) =>
  (next) =>
  (action: AnyAction) => {
    if (action.type in actionsMap) {
      dispatch(actionsMap[action.type](action?.payload))
    }
    if (action.type in dialogActionsMap) {
      if (action.type === redeemReplaceDialogActionName || action.type === redeemOpenDialogActionName) {
        const { modalName: dialogName, ...params } = action.payload
        dialogActionsMap[action.type]({ dialogName, ...params })
      } else {
        dialogActionsMap[action.type](action.payload)
      }
    }

    next(action)
  }
